import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { MobileNav } from './MobileNav';
import '../../../css/components/mobile-menu.css';

export const MobileMenu = () => {
	const [ open, setOpen ] = useState<boolean>(false);
	const menuButtonRef = useRef<HTMLButtonElement>(null);

	const handleToggle = () => {
		setOpen(current => !current);
	};

	const handleClose = () => {
		setOpen(false);
		menuButtonRef.current?.focus();
	};

	useEffect(() => {
		if(!open) return;
		const handleKeyDown = (event: KeyboardEvent) => {
			if(event.key === 'Escape') handleClose();
		};
		document.addEventListener('keydown', handleKeyDown);
		return () => document.removeEventListener('keydown', handleKeyDown);
	}, [open]);

	return (
		<>
			<button
				ref={menuButtonRef}
				className="btn-burger"
				onClick={handleToggle}
				id="btn-mobile-menu"
				aria-controls="mobile-menu"
				aria-expanded={open}
				aria-label={open ? 'Close navigation menu' : 'Open navigation menu'}
			>
				{open ? (
					<FontAwesomeIcon icon={faTimes} className="text-c-primary text-4xl"/>
				) : (
					<>
						<div/>
						<div/>
						<div/>
					</>
				)}
			</button>
			<div
				className={`mobile-menu absolute shadow-lg bg-white
				left-0 top-full w-full z-50 duration-500
				bg-c-primary overflow-y-auto ${open ? 'active' : ''}`}
				id="mobile-menu"
				role="navigation"
				aria-label="Site navigation"
				aria-hidden={!open}
				hidden={!open}
			>
				<MobileNav
					open={open}
					onClick={handleClose}
				/>
			</div>
		</>
	);
};
